import type { Row } from "./types";

/** Fetch the index once and keep it. There is no second request. */
export async function loadIndex(): Promise<Row[]> {
  const res = await fetch("/api/index.json.gz", { credentials: "same-origin" });
  if (res.status === 401) throw new Error("unauthorised");
  if (!res.ok) throw new Error(`index failed: ${res.status}`);
  return (await res.json()) as Row[];
}

/** How often the open page renews its session. The server's signature lasts
 *  five minutes (SESSION_MAX_AGE in api/main.py), so this survives a missed
 *  renewal or two -- and a closed tab, which renews nothing, is locked out
 *  within five. */
export const RENEW_MS = 60_000;

/** Re-sign the session. Throws "unauthorised" once it has lapsed. */
export async function renewSession(): Promise<void> {
  const res = await fetch("/api/refresh", { method: "POST", credentials: "same-origin" });
  if (res.status === 401) throw new Error("unauthorised");
}

/** Drop the session cookie. keepalive, because this is called from pagehide,
 *  where an ordinary request is cancelled along with the page. Fire and forget:
 *  if it never lands, the five-minute signature is the backstop. */
export function endSession(): void {
  fetch("/api/logout", { method: "POST", credentials: "same-origin", keepalive: true })
    .catch(() => {});
}
